import React from 'react'
import Skeleton from 'react-loading-skeleton'

export default function SkeletonLoadFormData() {
  return (
    <div>   
      <Skeleton height={40} width={280} />
      <div className="row mb-3">
        {Array(6).fill().map(()=>(
          <div className='col-md-6 mt-3'>
            <Skeleton height={25} />
          </div>
        ))}
      </div>
      <Skeleton height={40} width={280} />
    </div>
  )
}
